var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('PaymentForm', {
    attrs: {
      "bulk": true,
      "forClient": true,
      "activeSub": _vm.activeSub,
      "groupRedirect": true
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7dfa500","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/Pages/BulkUpload/BulkPayment.vue
// module id = B7yK
// module chunks = 2